import BlocksPage from "../components/templates/BlocksPage"

export default function Blocks(props) {
  return <BlocksPage {...props} />
}
